import React from 'react'
import moment from 'moment';
import { uniq } from 'lodash';
import { formatAddress } from 'helpers/address';
import { MILITARY_FORMAT } from 'helpers/datetime';

class BulkAcceptComponent extends React.Component {

  renderDate = job => {
    const moreDays = uniq([job.startTime, job.endTime].map((date) => moment(date, MILITARY_FORMAT).format('MM/DD/YY'))).length === 2
    const startTime = moment(job.startTime, MILITARY_FORMAT);
    const endTime = moment(job.endTime, MILITARY_FORMAT);

    if (moreDays) {
      return <React.Fragment>
        <span>{startTime.format('ddd., MMMM DD')}</span>
        {' - '}
        {startTime.format('h:mm A')}
        {' to '}
        <span>{endTime.format('ddd., MMMM DD')}</span>
        {' - '}
        {endTime.format('h:mm A')}
      </React.Fragment>
    }

    return <React.Fragment>
      <span>{startTime.format('ddd., MMMM DD')}</span>
      {' - '}
      {startTime.format('h:mm A')}
      {' to '}
      {endTime.format('h:mm A')}
    </React.Fragment>
  }

  render() {
    const { user, eventLocation, jobs } = this.props;

    return (
      <div className='additional-shifts-modal'>
        <p className='normal-text'><span>{`${user.firstName} ${user.lastName}`}</span> has applied to multiple shifts at this location.</p>
        <p className='normal-text'>Would you like to accept them for <span>all of the following shifts?</span></p>
        <p className='normal-text location-address'><span>Location:</span> {formatAddress(eventLocation)}</p>
        <p className='normal-text'><span>Shifts:</span></p>
        <div>
          {
            jobs?.map(job => <div className='job-details mt-2' key={job.id}>
              {this.renderDate(job)}
            </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default BulkAcceptComponent;
